import React from 'react';
import BaseModal from '../BaseModal';
import { modalNames } from '../../../../shared/configs/modal';
import { lifeCycleEntitiesMap } from '../../constants';
import { useAcceptanceViewFlatsInvalidate } from '../../../../api/acceptanceViewFlats';
import { useChangeRoomAcceptanceStatusMutation } from '../../../../api/changeRoomAcceptanceStatus';
import SelectAcceptanceStatus from '../SelectAcceptanceStatus';

const ChangeAcceptanceStatusModal = () => {
  const invalidateFlats = useAcceptanceViewFlatsInvalidate();

  const { mutateAsync, isLoading } = useChangeRoomAcceptanceStatusMutation({
    onSuccess: () => {
      invalidateFlats();
    },
  });

  const getOnSubmit = ({ closeModal }) => {
    return async (values) => {
      await mutateAsync(values);
      closeModal();
    };
  };

  return (
    <BaseModal
      name={modalNames.changeRoomAcceptanceStatus}
      getInitialValue={getInitialValue}
      getOnSubmit={getOnSubmit}
      entity={lifeCycleEntitiesMap.acceptanceStatus}
      confirmLoading={isLoading}
    >
      <SelectAcceptanceStatus />
    </BaseModal>
  );
};

export default ChangeAcceptanceStatusModal;

function getInitialValue(room, lifeCycleState) {
  return typeof lifeCycleState === 'object'
    ? lifeCycleState?.acceptanceStatus?.id
    : room?.recordInfo?.acceptanceStatusAddressLifeCycle?.id;
}
